import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./CardsRouter'),
  loading: () => <Loading withContentWrapper />,
});

export const Form = Loadable({
  loader: () => import('./containers/CardsFormPage/CardsFormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const Analytics = Loadable({
  loader: () => import('./containers/CardsAnalyticsPage/CardsAnalyticsPage'),
  loading: () => <Loading withContentWrapper />,
});

export const Preview = Loadable({
  loader: () => import('./containers/CardsPreviewPage/CardsPreviewPage'),
  loading: () => <Loading visible fullScreen />,
});

export const List = Loadable({
  loader: () => import('./containers/CardsList/CardsList'),
  loading: () => <Loading withContentWrapper />,
});
